import Navbar from '../../components/Navbar/Navbar'
import Hero from '../../components/hero3/hero3';
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import ProjectSection from '../../components/ProjectSectionHome/ProjectSectionHome';
import FunFact from '../../components/FunFact/FunFact';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.png'
import FaqSection from '../../components/FaqSection/FaqSection';
import VideoSectionHome from '../../components/VideoSectionHome/VideoSection';
import ContactSection from '../../components/Contactsection/ContactSection';

const HomePage = () => {
  return (
    <>
      <Navbar hclass={"wpo-site-header wpo-site-header-s2"} Logo={Logo} />
      <Hero />
      <ProjectSection hclass={"project_section section-padding"} sliceEnd={3} />
      <ServiceSection hclass={"service_section section-padding"} />
      <FunFact hclass={"funfact_section"} />
      <VideoSectionHome title="Vanguardia en equipos" subtitle="Tecnologias" />
      <FaqSection />
      <ContactSection />
      <Footer hclass={"wpo-site-footer"} />
      <Scrollbar />
    </>
  );
};
export default HomePage;